import { gql } from "@apollo/client";

export const listProductGroups = gql`
  query ListProductGroups($filters: KeywordGroupFilter) {
    listKeywordGroups(type: "PRODUCT_GROUP", filters: $filters) {
      id
      name
      type
      slug
      imageUrl
      keywords
      keywordsGroupIds
      deleted
      metadata
      category
      isLinked
      linkedTo {
        attachedTo
        id
        name
      }
    }
  }
`;
